import type { ReactNode } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';

import type { PracticeAccessSource } from '@nesso/practice-contracts/practice-access-rule.access-sources';

import { practiceMemberOptions } from '../api/practice-member.queries';
import { getMissingAccessSources } from '../model/get-missing-access-sources';

type Props<S extends PracticeAccessSource[]> = {
    requiredAccessSources: S;
    fallback?: (missing: S[number][]) => ReactNode;
    children: ReactNode;
};

export function PermissionGate<S extends PracticeAccessSource[]>({
    requiredAccessSources,
    fallback,
    children,
}: Props<S>) {
    const { data } = useSuspenseQuery(practiceMemberOptions());
    const missing = getMissingAccessSources(data.accessSources, requiredAccessSources);

    if (missing.length > 0) return fallback?.(missing) ?? null;

    return children;
}
